module.exports = __webpack_public_path__ + "media/SuiteApp/assets/svg/img/edit-c8f2be5b72c6050ad79180d3af8f711c.svg";